import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DateFormatter from 'common/utils/DateFormatter';
import Button from 'common/components/elements/buttons/primary';
import ImgGallery from 'common/components/modules/img-gallery';
import './style.scss'
import Icon from 'common/components/elements/icons';
import cx from 'classnames'
import storeHelper from 'common/utils/store-helper';
import { setShowNSFWModalAction } from 'sites/state/modules/common/actions';
import { useDispatch } from 'react-redux';
import {
   MediaLableItem,
   MediaMemberBottonOptions,
} from 'common/components/modules/media';


const StoreImgCard = ({
   src,
   className,
   isShowPrice,
   isMobile,
   isDetails,
   showComingSoon,
   date,
   onShare,
   id,
   data,
   siteInfo,
   showPremiumLabel,
   hidePrices,
   onChangeFavoriteItem,
   hideFavorite,
   isShowAttachmentLabel,
   isLockedForSFW,
}) => {
   let showQuentity = !!data?.track_quantity && !showComingSoon && !isDetails && !!data?.show_availability
   const endsInDate = data.product_type === 'content_bundle_item' ? data?.ends_in_bundle : !!data?.show_public_countdown ? data?.ends_in : null
   let calculateTimeLeft = () => DateFormatter.calculateTimeLeft(endsInDate)
   const [timeLeft, setTimeLeft] = useState(endsInDate ? calculateTimeLeft() : null);
   const [hideTimeLeft, setHideTimeLeft] = useState(false)
   const dispatch = useDispatch()

   let leftDate = null;
   if(showComingSoon){
      leftDate = DateFormatter.getDateLeft(date, false, 'In a few minutes');
   }
   let newImgArray = []
   if(!!data && !!data.image_full_src){
      newImgArray = [...JSON.parse((data && data?.image_full_src) && data?.image_full_src)]
   }

   const images = newImgArray?.map(item => {
      return { original: item,
         thumbnail: item,
      }
   })

   useEffect(() => {
      let timer
      if(timeLeft !== null) {
         timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
         }, 1000);
      }

      return () => clearInterval(timer);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [timeLeft]);

   return (
      <div
         className={ `bg-cover bg-center select-none flex flex-col items-start relative h-full w-full overflow-hidden ${ className }` }
         role='presentation'
         onMouseEnter={ () => {
            setHideTimeLeft(true)
         } }
         onMouseLeave={ () => {
            setHideTimeLeft(false)
         } }
      >
         <div className='h-full w-full relative'>
            <div className='aspect-ratio-padding' />
            <div className='absolute top-0 left-0 w-full h-full store-top-content-height z-[1]'

            >
               <div className={ `text-major-dark w-full h-full overflow-hidden ${ isDetails && isMobile ? '' : 'rounded-label' }` } >
                  <ImgGallery
                     images={ images }
                     showFullScreen={ false }
                     classNameIconDiv='next-icon-classes z-40 mms-media-button-wrapper-bg'
                     isLockedForSFW={ isLockedForSFW }
                     showBullets
                  />

                  <div
                     className={ `w-full h-full absolute top-0 left-0 bg-contain bg-center bg-no-repeat ${ isMobile ? '' : ' rounded-lg' }` }
                     style={
                        {
                           backgroundImage: `url(${ src })`,
                        }
                     }
                  >
                  </div>
                  <div
                     className={
                        cx({
                           'absolute top-0 left-0 pt-2 p-2 w-full flex justify-between items-center rounded-t-lg': true,
                           '!justify-end': !['content_bundle_item', 'attachment_item'].includes(data.product_type),
                        })
                     }
                  >
                     {
                        data.product_type === 'attachment_item' && isShowAttachmentLabel &&
                        <MediaLableItem
                           iconName={ data?.attachment_type === 'rar' ? 'zip' : data?.attachment_type }
                           tooltipContent={ `Downloadable ${ data?.attachment_type !== 'audio' ? data?.attachment_type === 'image' ? 'Image' : `${ data?.attachment_type?.toUpperCase() } file` : 'Audio file' }` }
                        />
                     }
                     {
                        data.product_type === 'content_bundle_item' && (
                           <div className='flex gap-2 items-center'>
                              {
                                 showPremiumLabel &&
                                 <MediaLableItem
                                    tooltipContent='Premium'
                                    iconName='star'
                                    iconColor='warning'
                                    withoutBackground

                                 />
                              }
                              <MediaLableItem
                                 tooltipContent='Bundle'
                                 iconName='bundle'
                              />
                           </div>
                        )
                     }
                     {
                        !hidePrices && !isShowPrice &&
                           <MediaLableItem
                              text={ storeHelper.getStorePrice(data) }
                           />
                     }
                  </div>
                  {
                     !!showComingSoon && !hideTimeLeft && (
                        <div
                           className={ `absolute w-full text-major-dark bg-no-repeat non-published-bg bg-major-60 dark:bg-grey-hover-dark-60  bg-cover inset-0 flex flex-col items-center justify-center ${ isDetails && isMobile ? '' : 'rounded-label' }` }>
                           <div className='flex flex-col justify-center items-center z-20'>
                              <span className='font-bold coming-soon-text'>Coming soon</span>
                              <span className='leading-tight mt-2 text-center'>{leftDate}</span>
                           </div>
                        </div>
                     )
                  }
                  {
                     !showComingSoon && !!timeLeft &&
                     <div
                        role='presentation'
                        className={ `non-published-bg bg-major-60 dark:bg-grey-hover-dark-60  rounded-lg absolute top-0 z-10 left-0 w-full h-full flex flex-col items-center justify-center gap-2` }
                        style={ {
                           visibility: hideTimeLeft ? 'hidden' : '',
                        } }
                     >
                        <Icon
                           name='clock'
                           color='major-dark'
                           size='2xl'
                        />
                        <span className=' text-major-dark text-xl leading-4 font-medium select-none'>Ends in</span>
                        <span className=' text-major-dark block select-none'>{timeLeft}</span>
                     </div>
                  }
                  {
                     !!hideTimeLeft && !!isLockedForSFW &&
                     <div
                        className={ cx({
                           'absolute top-0 flex flex-col items-center justify-center gap-4 w-full h-full z-1 bg-major-60': true,
                           'rounded-label': !isDetails && !isMobile,
                        }) }
                        style={ {
                           backdropFilter: 'blur(32px)',
                        } }
                     >
                        <p className='text-lg font-semibold text-major-dark text-center'>Verify age to unblur content</p>
                        <Button
                           text={  'Verify my age' }
                           borderRadius='large'
                           backgroundColor={ 'transparent' }
                           textColor='major-dark'
                           textSize='small'
                           onClick={ (e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              dispatch(setShowNSFWModalAction(true))
                           } }
                           classNames='!w-fit border border-major-dark py-2.5 px-3.5'
                           textMarginX='0'
                        />
                     </div>
                  }
               </div>
            </div>
         </div>
         <div
            className={ cx({
               'flex justify-between items-center gap-3 p-2 pt-3 w-full absolute bottom-0 right-0 z-2 rounded-b-lg': true,
               '!justify-end': !showQuentity,
            }) }
         >

            {
               showQuentity &&
               <MediaLableItem
                  iconName={ !!data?.number_in_stock_left ? 'store' : 'sold-out' }
                  text={ !!data?.number_in_stock_left ? `${ data?.number_in_stock_left } of ${ data?.number_in_stock } left` : data?.label }
               />
            }
            <MediaMemberBottonOptions
               canShare={ siteInfo?.content_card_settings?.share && !!onShare }
               onShare={ (e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  onShare(id, 'store')
               } }
               canChangeFavorite={ !hideFavorite }
               onChangeFavoriteItem={ e => {
                  e.stopPropagation()
                  e.preventDefault()
                  onChangeFavoriteItem(id, 'store')
               } }
               isFavorite={ data.is_favorite }
            />
         </div>
      </div>
   );
};

StoreImgCard.propTypes = {
   src: PropTypes.string,
   className: PropTypes.string,
   isShowPrice: PropTypes.bool,
   isMobile: PropTypes.bool,
   isDetails: PropTypes.bool,
   showComingSoon: PropTypes.bool,
   date: PropTypes.string,
   onShare: PropTypes.func,
   id: PropTypes.number,
   data: PropTypes.any,
   siteInfo: PropTypes.object,
   showPremiumLabel: PropTypes.bool,
   hidePrices: PropTypes.bool,
   onChangeFavoriteItem: PropTypes.func,
   hideFavorite: PropTypes.bool,
   isShowAttachmentLabel: PropTypes.bool,
   isLockedForSFW: PropTypes.bool,
};

StoreImgCard.defaultProps = {
   className: '',
   isShowPrice: true,
   isMobile: false,
   isDetails: false,
   showPremiumLabel: false,
   hidePrices: false,
   onChangeFavoriteItem: () => {},
   hideFavorite: false,
   isShowAttachmentLabel: true,
}

export default StoreImgCard;
